import { useQuery } from "@tanstack/react-query";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";

export type TrackingPopData = {
    전화번호: string;
    운송장번호: string;
    접수일자: string;
    운임: string;
    발송구분: string;
    지불방법: string;
    요금처: string;
    담당자: string;
    수량: number;
    출발지상호: string;
    출발지신용정보: string;
    출발지연락처: string;
    출발지담당자: string;
    출발지주소: string;
    도착지상호: string;
    도착지신용정보: string;
    도착지연락처: string;
    도착지담당자: string;
    도착지주소: string;
};

type GetTrackingPopResponse = {
    statusCode: number;
    message: string;
    data: TrackingPopData;
};

export const useGetTrackingPopBill = (bl_no: string, enabled: boolean = true) => {
    return useQuery<TrackingPopData>({
        queryKey: ["useGetTrackingPopBill", bl_no],
        queryFn: async () => {
            const { data } = await axiosInstance.get<GetTrackingPopResponse>(`${enum_api_uri.tracking_pop_bill}?bl_no=${bl_no}`);
            return data.data;
        },
        enabled: !!bl_no && enabled,
    });
};
